import React, { useState, useEffect } from 'react';
import Search from '../searchComponents/Search';
import DatahubAPI from '../../../api/DatahubAPI';
import SubscribeModal from '../../SubscribeModal';
import { Redirect } from 'react-router-dom';
import { Typography } from '@mui/material';
import { Player } from '@lottiefiles/react-lottie-player';
import { Modal } from '@mui/material';
import DateSelector from '../filters/DateSelector';
import { format } from 'date-fns';

interface ICyberProps {
  setShowFullRecord: any;
  showFilters: boolean;
  cur_user: any;
  activeSub: any;
  userHasCyberSearch: boolean;
  matchedTeamWithStripe: any;
  inputs: any;
  setInputs: any;
  page: number;
  setPage: any;
}

const Cyber: React.FC<ICyberProps> = ({ inputs, setInputs, page, setPage, activeSub, userHasCyberSearch, matchedTeamWithStripe, cur_user, setShowFullRecord }) => {
  const [ cyberState, setCyberState ] = useState({
    fuzzy: true,
    date: null,
    dateRange: []
  });

  const [ cyberFiltersTotal, setCyberFiltersTotal ] = useState<any>({ isLoading: true, data: 0 });
  const [ cyberReturns, setCyberReturns ] = useState<any>({ isLoading: true, data: [] });
  const [ submit, setSubmit ] = useState<boolean>(false);
  const [ cyberTab, setCyberTab ] = useState('CVE');
  const [ indices, setIndices ] = useState([ 'Cyber_Protection_KEV_Alias' ]);
  const [ cyberHeaders, setCyberHeaders ] = useState<string[]>([ 'CVE ID', 'Vendor Project', 'Product', 'Vulnerability Name', 'Required Action' ]);
  const [ openDate, setOpenDate ] = useState(false);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const handleTabSwitch = (newTab: string) => {
    setInputs([
      {
        primary: '',
      }
    ]);
    switch (newTab) {
    case 'CVE':
      setCyberHeaders([ 'CVE ID', 'Vendor Project', 'Product', 'Vulnerability Name', 'Required Action' ]);
      setCyberTab('CVE');
      setIndices([ 'Cyber_Protection_KEV_Alias' ]);
      setSubmit(!submit);
      break;
    case 'Markets':
      setCyberHeaders([ 'Market Name', 'Description', 'Website', 'Market Location' ]);
      setCyberTab('Markets');
      setIndices([ 'Cyber_Protection_Notorious_Markets_Alias' ]);
      setSubmit(!submit);
      break;
    default:
      setCyberTab('CVE');
    }
  };

  const getCyCSVResults = async(queryInputs: any, pageNum: number) => {
    const allResults: any = [];
    const query = {
      primary: inputs.cyber,
      indices: indices,
      pageNum: pageNum,
      dateRange: cyberState.dateRange,
      fuzziness: cyberState.fuzzy ? 'AUTO' : 0,
      qty: 200
    };
    const res = await DatahubAPI.entitySearch(query);
    if (res?.success) {
      allResults.push(res?.result);
    }
    return allResults;
  };

  const getFiltersTotal = async() => {
    const filtersQuery: any = {
      indices: indices,
      dateRange: cyberState.dateRange,
      fuzziness: 0,
    };
    const res = await DatahubAPI.cyberSearch(filtersQuery);
    if (res?.success) {
      setCyberFiltersTotal({ isLoading: false, data: res?.result?.result?.body?.hits?.total?.value });
    }
  };

  const handleSubmit = async(pageNum: number) => {
    setCyberReturns({ isLoading: true, data: [] });
    const allResults: any = [];
    const query = {
      primary: inputs.cyber,
      indices: indices,
      pageNum: pageNum,
      dateRange: cyberState.dateRange,
      fuzziness: cyberState.fuzzy ? 'AUTO' : 0,
    };
    const res = await DatahubAPI.cyberSearch(query);
    if (res?.success) {
      allResults.push(res?.result);
      setCyberFiltersTotal({ isLoading: false, data: res?.result?.result?.body?.hits?.total?.value });
    }

    setCyberReturns({ isLoading: false, data: allResults });
  };

  const handleMultiPageChange = async(input: any, pageNum: number, i: number) => {
    setCyberReturns({ isLoading: true, data: [] });
    const allResults: any = cyberReturns.data;
    const query = {
      primary: input,
      indices: indices,
      pageNum: pageNum,
      dateRange: cyberState.dateRange,
      fuzziness: cyberState.fuzzy ? 'AUTO' : 0,
    };
    const res = await DatahubAPI.entitySearch(query);
    if (res?.success) {
      allResults[i] = res?.result;
      setCyberFiltersTotal({ isLoading: false, data: res?.result?.result?.body?.hits?.total?.value });
    }
    setCyberReturns({ isLoading: false, data: allResults });
  };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCyberState({ ...cyberState, fuzzy: event.target.checked });
  };


  const handleDateChange = (newValue: any) => {
    const arr: any = [ ...newValue ];
    if (newValue[0] !== null) {
      arr.forEach((dt: any, index: number) => {
        if (dt !== null) {
          const dtWithoutTz = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
          const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');
          arr[index] = formatted_dt;
        }
      });
      setCyberState({ ...cyberState, date: newValue, dateRange: arr });
    } else {
      setCyberState({ ...cyberState, date: null, dateRange: [] });
    }
  };

  useEffect(() => {
    handleSubmit(page);
  }, []);

  useEffect(() => {
    handleSubmit(0);
  }, [ cyberTab, submit ]);

  useEffect(() => {
    getFiltersTotal();
  }, [ indices ]);

  useEffect(() => {
    setPage(0);
  }, [ inputs ]);

  return (
    <div className='screening-body-container'>
      {activeSub === 'BITE Pro' ||
      activeSub === 'BITE Enterprise' &&
      !userHasCyberSearch ? (
          <div className='no-license-modal-screening'>
            <Player
              autoplay
              loop
              src='https://lottie.host/3c23c1ad-7f71-4e3d-8f19-69154715dbdc/SdWWjCmU1J.json'
              style={{ width: '20%' }}
            >
            </Player>
            <Typography variant='h6' className='text-white'
              style={{
                fontSize: '20px',
                fontWeight: 700,
                lineHeight: '24px',
                letterSpacing: '0.15px'
              }}
            >
            You need an assigned license to access this module
            </Typography>
            <Typography variant='h6'
              style={{
                fontSize: '18px',
                fontWeight: 700,
                lineHeight: '24px',
                letterSpacing: '0.15px',
                marginTop: '20px',
                color: '#BDBEC1'
              }}
            >
            Visit Account &gt; Users &gt; to assign
            an available license to your user or contact your team admin
            </Typography>
          </div>
        ) : (
          !userHasCyberSearch ? (
            <SubscribeModal
              name='Screening'
              screening={true}
              description='Quickly search for high risk people, companies and products as well as cyber threat indicators.'
              price={25}
              curUser={cur_user}
              stripeTeam={matchedTeamWithStripe}
              activeSub={activeSub}
            />
          ) : <></>
        )}

      <Search
        userHasSearch={userHasCyberSearch}
        setShowFullRecord={setShowFullRecord}
        type={'Cyber'}
        handleSubmit={handleSubmit}
        inputs={inputs}
        setInputs={setInputs}
        results={cyberReturns}
        page={page} setPage={setPage}
        cyberTab={cyberTab}
        handleTabSwitch={handleTabSwitch}
        cyberHeaders={cyberHeaders}
        getCSVResults={getCyCSVResults}
        handleMultiPageChange={handleMultiPageChange}
        state={cyberState}
        handleSwitchChange={handleSwitchChange}
        handleOpenDate={() => setOpenDate(true)}
      />
      <Modal
        open={openDate}
        onClose={() => setOpenDate(false)}
      >
        <DateSelector
          openDate={openDate}
          setOpenDate={setOpenDate}
          state={cyberState}
          handleDateChange={handleDateChange}
          setSubmit={setSubmit}
          submit={submit}
        />
      </Modal>
    </div>

  );
};

export default Cyber;
